// インポート部分
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
// CSSのインポート
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { speed } from 'jquery';

// メインビジュアル
const topmvSwiper = new Swiper('.top-mv-Swiper', {
  modules: [EffectFade, Navigation, Pagination, Autoplay],
  effect: "fade",
  speed: 3000,
  spaceBetween: 1500,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
});

// ブライダルフェア
const topbridalfairSwiper = new Swiper('.top-bridalfair-Swiper', {
  modules: [Navigation, Pagination, Autoplay, EffectFade], // 必要に応じてEffectFadeを追加
  slidesPerView: 'auto',
  spaceBetween: 0,
  loop: true,
  speed: 1000,
  cssMode: false,
  effect: 'slide',
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.custom-next-button',
    prevEl: '.custom-prev-button'
  }
});

// アバウト
const topaboutSwiper = new Swiper('.top-about-Swiper', {
  modules: [EffectFade, Navigation, Pagination, Autoplay],
  effect: "fade",
  speed: 3000,
  spaceBetween: 1500,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
});

// セレモニー
const topceremonySwiper = new Swiper('.top-ceremony-Swiper', {
  modules: [EffectFade, Navigation, Pagination, Autoplay],
  effect: "fade",
  speed: 3000,
  spaceBetween: 1500,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
});

// パーティー
const toppartySwiper = new Swiper('.top-party-Swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 5,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 5,
    },
    1081: {
      spaceBetween: 2,
    }
  }
});

// キュイジーヌ
const topcuisineSwiper = new Swiper('.top-cuisine-Swiper', {
  modules: [EffectFade, Navigation, Pagination, Autoplay],
  effect: "fade",
  speed: 3000,
  spaceBetween: 1500,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
});

// プラン
const topplanswiper = new Swiper('.top-plan-Swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 1000,
  loop: false,
  autoplay: false,  // デフォルトでオフ
  navigation: {
    nextEl: '.plan-next-button',
    prevEl: '.plan-prev-button'
  },
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      enabled: true,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      }
    },
    1081: {
      enabled: false,
      slidesPerView: 4,
    }
  }
});

// 限定特典
const toppresentSwiper = new Swiper('.top-present-Swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 40,
  breakpoints: {
    0: {
      spaceBetween: 25
    },
    1081: {
      spaceBetween: 40
    }
  },
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.present-next-button',
    prevEl: '.present-prev-button'
  }
});

// ウェディングコンテンツ
const commonweddingcontentsSwiper = new Swiper('.common-weddingcontents-Swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: `.weddingcontents-pagination`,
    clickable: true,
    type: 'bullets',
  }
});

const okurastorySwiper = new Swiper('.okura-story-Swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 0,
  loop: true,
  speed: 1000,
  loopedSlides: 6,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.okura-story-Swiper .swiper-pagination', // セレクタを具体的に
    clickable: true,
    type: 'bullets',
    renderBullet: function (index, className) {
      if (index < 3) {
        return '<span class="' + className + '"></span>';
      }
      return '';
    }
  },
  on: {
    beforeInit: function (swiper) {
      const slides = swiper.el.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        swiper.el.querySelector('.swiper-wrapper').appendChild(clone);
      });
    },
    slideChange: function (swiper) {
      const realIndex = swiper.realIndex % 3;
      // 現在のスワイパーのページネーションのみを取得
      const bullets = swiper.el.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet, index) => {
        if (index === realIndex) {
          bullet.classList.add('swiper-pagination-bullet-active');
        } else {
          bullet.classList.remove('swiper-pagination-bullet-active');
        }
      });
    }
  }
});

const okurabeautySwiper = new Swiper('.okura-beauty-Swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 0,
  loop: true,
  speed: 1000,
  loopedSlides: 6,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.okura-beauty-Swiper .swiper-pagination', // セレクタを具体的に
    clickable: true,
    type: 'bullets',
    renderBullet: function (index, className) {
      if (index < 3) {
        return '<span class="' + className + '"></span>';
      }
      return '';
    }
  },
  on: {
    beforeInit: function (swiper) {
      const slides = swiper.el.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        swiper.el.querySelector('.swiper-wrapper').appendChild(clone);
      });
    },
    slideChange: function (swiper) {
      const realIndex = swiper.realIndex % 3;
      // 現在のスワイパーのページネーションのみを取得
      const bullets = swiper.el.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet, index) => {
        if (index === realIndex) {
          bullet.classList.add('swiper-pagination-bullet-active');
        } else {
          bullet.classList.remove('swiper-pagination-bullet-active');
        }
      });
    }
  }
});

const okurabeautySwiper_5 = new Swiper('.okura-beauty-Swiper_5', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 1000,
  loop: true,
  loopedSlides: 10,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.okura-beauty-Swiper_5 .swiper-pagination', // セレクタを具体的に
    clickable: true,
    type: 'bullets',
    renderBullet: function (index, className) {
      if (index < 5) {
        return '<span class="' + className + '"></span>';
      }
      return '';
    }
  },
  on: {
    beforeInit: function (swiper) {
      const slides = swiper.el.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        swiper.el.querySelector('.swiper-wrapper').appendChild(clone);
      });
    },
    slideChange: function (swiper) {
      const realIndex = swiper.realIndex % 5;
      // 現在のスワイパーのページネーションのみを取得
      const bullets = swiper.el.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet, index) => {
        if (index === realIndex) {
          bullet.classList.add('swiper-pagination-bullet-active');
        } else {
          bullet.classList.remove('swiper-pagination-bullet-active');
        }
      });
    }
  }
});


// const placelisttemplatecontentSwiper = new Swiper('.placelist-template-content-Swiper', {
//   modules: [Navigation, Pagination, Autoplay],
//   slidesPerView: 'auto',
//   spaceBetween: 0,
//   speed: 1000,
//   loop: true,
//   autoplay: {
//     delay: 4000,
//     disableOnInteraction: false,
//   }
// });


//会場一覧テンプレート

// 共通の設定をオブジェクトとして定義
const placelisttemplatecontentOptions = {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
};

// スライダーの設定を配列で管理
const placelisttemplatecontentConfigs = [
  {
    className: '.placelist-grandchapel-Swiper',
    paginationClass: 'grandchapel-pagination'
  },
  {
    className: '.placelist-skychapel-Swiper',
    paginationClass: 'skychapel-pagination'
  },
  {
    className: '.placelist-shrine-Swiper',
    paginationClass: 'shrine-pagination'
  },
  {
    className: '.placelist-orchard-Swiper',
    paginationClass: 'orchard-pagination'
  },
  {
    className: '.placelist-maple-Swiper',
    paginationClass: 'maple-pagination'
  },
  {
    className: '.placelist-lune-Swiper',
    paginationClass: 'lune-pagination'
  },
  {
    className: '.placelist-etoile-Swiper',
    paginationClass: 'etoile-pagination'
  },
  {
    className: '.placelist-akebono-Swiper',
    paginationClass: 'akebono-pagination'
  }
];

// スライダーを初期化
placelisttemplatecontentConfigs.forEach(config => {
  // スライダーのインスタンスを作成
  const swiper = new Swiper(config.className, {
    ...placelisttemplatecontentOptions,
    pagination: {
      el: `.${config.paginationClass}`,
      clickable: true,
      type: 'bullets',
    }
  });
});





const palcedetailinteriorswiper = new Swiper('.placedetail-interior-Swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 2.5,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: 'bullets',
  },
  // ナビゲーションボタンの設定を追加
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

// const facilitycontentSwiper = new Swiper('.facility-content-Swiper', {
//   modules: [Navigation, Pagination, Autoplay],
//   slidesPerView: 'auto',
//   spaceBetween: 3,
//   loop: true,
//   autoplay: {
//     delay: 4000,
//     disableOnInteraction: false,
//   },
//   // ナビゲーションボタンの設定を追加
//   navigation: {
//     nextEl: '.custom-next-button',
//     prevEl: '.custom-prev-button',
//   },
//   on: {
//     beforeInit: function (swiper) {
//       const multiplyCount = 3;
//       const slides = swiper.el.querySelectorAll('.swiper-slide');
//       const wrapper = swiper.el.querySelector('.swiper-wrapper');

//       // 指定した回数分繰り返す
//       Array.from({ length: multiplyCount }).forEach(() => {
//         slides.forEach(slide => {
//           const clone = slide.cloneNode(true);
//           wrapper.appendChild(clone);
//         });
//       });
//     }
//   }
// });




// const facilityotherSwiper = new Swiper('.facility-otherspot-Swiper', {
//   modules: [Navigation, Pagination, Autoplay],
//   slidesPerView: 'auto',
//   spaceBetween: 3,
//   loop: true,
//   autoplay: {
//     delay: 4000,
//     disableOnInteraction: false,
//   },
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//     type: 'bullets',
//   },
//   // ナビゲーションボタンの設定を追加
//   navigation: {
//     nextEl: '.custom-next-button',
//     prevEl: '.custom-prev-button',
//   }
// });


//施設ページ

// 共通の設定をオブジェクトとして定義
const facilitycommonOptions = {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 3,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
};

// スライダーの設定を配列で管理
const facilitysliderConfigs = [
  {
    className: '.facility-lobby-Swiper',
    paginationClass: 'lobby-pagination',
    nextButtonClass: 'lobby-next-button',
    prevButtonClass: 'lobby-prev-button'
  },
  {
    className: '.facility-garden-Swiper',
    paginationClass: 'garden-pagination',
    nextButtonClass: 'garden-next-button',
    prevButtonClass: 'garden-prev-button'
  },
  {
    className: '.facility-okurasquare-Swiper',
    paginationClass: 'okurasquare-pagination',
    nextButtonClass: 'okurasquare-next-button',
    prevButtonClass: 'okurasquare-prev-button'
  },
  {
    className: '.facility-otherspot-Swiper',
    paginationClass: 'otherspot-pagination',
    nextButtonClass: 'otherspot-next-button',
    prevButtonClass: 'otherspot-prev-button'
  },
  {
    className: '.facility-guestroom-Swiper',
    paginationClass: 'guestroom-pagination',
    nextButtonClass: 'guestroom-next-button',
    prevButtonClass: 'guestroom-prev-button'
  },
  {
    className: '.facility-restaurant-Swiper',
    paginationClass: 'restaurant-pagination',
    nextButtonClass: 'restaurant-next-button',
    prevButtonClass: 'restaurant-prev-button'
  },
  {
    className: '.facility-restaurantlist-Swiper',
    paginationClass: 'restaurantlist-pagination',
    nextButtonClass: 'restaurantlist-next-button',
    prevButtonClass: 'restaurantlist-prev-button'
  }

];

// スライダーを初期化
facilitysliderConfigs.forEach(config => {
  // スライダーのインスタンスを作成
  const swiper = new Swiper(config.className, {
    ...facilitycommonOptions,
    pagination: {
      el: `.${config.paginationClass}`,
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: `.${config.nextButtonClass}`,
      prevEl: `.${config.prevButtonClass}`,
    }
  });
});



//料理ページ

// 共通の設定をオブジェクトとして定義
const cuisinecommonOptions = {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 3,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
};

// スライダーの設定を配列で管理
const sliderConfigs = [
  {
    className: '.cuisine-french-Swiper',
    paginationClass: 'french-pagination',
    nextButtonClass: 'french-next-button',
    prevButtonClass: 'french-prev-button'
  },
  {
    className: '.cuisine-japanese-Swiper',
    paginationClass: 'japanese-pagination',
    nextButtonClass: 'japanese-next-button',
    prevButtonClass: 'japanese-prev-button'
  }
];

// スライダーを初期化
sliderConfigs.forEach(config => {
  new Swiper(config.className, {
    ...cuisinecommonOptions,
    pagination: {
      el: `.${config.paginationClass}`,
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: `.${config.nextButtonClass}`,
      prevEl: `.${config.prevButtonClass}`,
    }
  });
});


//ドレスページ

// 共通の設定をオブジェクトとして定義
const dresscommonOptions = {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 'auto',
  spaceBetween: 3,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  }
};

// スライダーの設定を配列で管理
const dresssliderConfigs = [
  {
    className: '.dress-vellferice-Swiper',
    paginationClass: 'vellferice-pagination',
    nextButtonClass: 'vellferice-next-button',
    prevButtonClass: 'vellferice-prev-button'
  },
  {
    className: '.dress-granmanie-Swiper',
    paginationClass: 'granmanie-pagination',
    nextButtonClass: 'granmanie-next-button',
    prevButtonClass: 'granmanie-prev-button'
  },
  {
    className: '.dress-authentique-Swiper',
    paginationClass: 'authentique-pagination',
    nextButtonClass: 'authentique-next-button',
    prevButtonClass: 'authentique-prev-button'
  },
  {
    className: '.dress-lesfeescouture-Swiper',
    paginationClass: 'lesfeescouture-pagination',
    nextButtonClass: 'lesfeescouture-next-button',
    prevButtonClass: 'lesfeescouture-prev-button'
  },
  {
    className: '.dress-custommade-Swiper',
    paginationClass: 'custommade-pagination',
    nextButtonClass: 'custommade-next-button',
    prevButtonClass: 'custommade-prev-button'
  },
  {
    className: '.dress-flower-Swiper',
    paginationClass: 'flower-pagination',
    nextButtonClass: 'flower-next-button',
    prevButtonClass: 'flower-prev-button'
  },
  {
    className: '.dress-coordinate-Swiper',
    paginationClass: 'coordinate-pagination',
    nextButtonClass: 'coordinate-next-button',
    prevButtonClass: 'coordinate-prev-button'
  },
  {
    className: '.dress-beauty-Swiper',
    paginationClass: 'beauty-pagination',
    nextButtonClass: 'beauty-next-button',
    prevButtonClass: 'beauty-prev-button'
  }
];

// スライダーを初期化
dresssliderConfigs.forEach(config => {
  new Swiper(config.className, {
    ...dresscommonOptions,
    pagination: {
      el: `.${config.paginationClass}`,
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: `.${config.nextButtonClass}`,
      prevEl: `.${config.prevButtonClass}`,
    }
  });
});
